import { ua } from '../../../../util/user-agent';

export class Controller {

    /** @ngInject */
    constructor(ExtentionManaging) {
        this.ExtentionManaging = ExtentionManaging;
    }

    $onInit() {
    }

    installExtension() {
        this.ExtentionManaging.installExtension();
    }

    installExtensionButtonVisible() {
        if (this.account.roles.includes('ROLE_HARD_TOKEN_USER')) {
            return false;
        }
        if (this.account.roles.includes('ROLE_SMS_USER')) {
            return false;
        }
        if (ua.isIOS()) {
            return false;
        }
        if (document.getElementById("saaspass-extension-info")) {
            return false;
        }
        if (document.getElementById('extension-is-installed-v2.0.1')) {
            return false;
        }
        if (document.getElementById('extension-is-installed-v2.1.0')) {
            return false;
        }
        return ((ua.isFirefox() || ua.isSafari() || ua.isChrome() || ua.isOpera()) && !ua.isIOS());
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/users-shared-accounts/header.controller.js